// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".chnk." + {"61":"f3a74dec3ecf33b67ac1","62":"24866fd7034ea2616ffd"}[chunkId] + ".js";
};